<template>
  <div class="countdown">
    {{ formattedTime }}
  </div>
</template>

<script>
export default {
  name: "CountdownTimer",
  props: {
    targetTime: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      remainingTime: this.targetTime,
      timer: null
    };
  },
  computed: {
    formattedTime() {
      const totalSeconds = Math.max(0, Math.floor(this.remainingTime / 1000));
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    }
  },
  mounted() {
    this.startTimer();
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        if (this.remainingTime <= 0) {
          this.stopTimer();
          this.$emit("countdown-finished");
          return;
        }
        this.remainingTime -= 1000;
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  },
  watch: {
    targetTime: {
      handler(newValue) {
        this.remainingTime = newValue;
        this.stopTimer();
        this.startTimer();
      },
      immediate: true
    }
  }
};
</script>
